import StyleSheet from 'react-native-media-query';

import breakpoints from './breakpoints';

export const { ids, styles } = StyleSheet.create({
  mobileOnly: {
    display: 'none',
    [`@media ${breakpoints.xs}`]: {
      display: 'flex',
    },
  },
  mobileAndTabletOnly: {
    display: 'flex',
    [`@media ${breakpoints.lg}`]: {
      display: 'none',
    },
  },
  tabletAndWebOnly: {
    display: 'none',
    [`@media ${breakpoints.md}`]: {
      display: 'flex',
    },
  },
  webOnly: {
    display: 'none',
    [`@media ${breakpoints.lg}`]: {
      display: 'flex',
    },
  },
});
